import { RedirectBannerDto, getRedirectionBannerEndpoint } from 'cpes-common';
import { createCmsContentSlice } from 'cms-integration';

const { reducer, fetchContent } = createCmsContentSlice<RedirectBannerDto>({
    contentName: 'redirectionBanner',
    contentEndpoint: getRedirectionBannerEndpoint,
});

export default reducer;
export const fetchRedirectionBanner = fetchContent;
